<template>
    <div>
        <div class="content-edit position-relative">
            <vue-mce :config="config" v-model="data"/>
            <div :class="{
                    'dialog-edit': true,
                    'dialog-edit-mobile': $detect == 'mobile'
                }">
                <ldc-dialog
                    title="Thêm ảnh"
                    :clickoutside="true"
                    colorTitle="#007bff"
                    width="50%"
                    :fullscreen="$detect == 'mobile' ? true : false"
                    :visible.sync="dialog">
                    <div class="my-img vg-scrollbar" v-loading="loading">
                        <div class="d-flex flex-wrap px-2 pb-3">
                            <div class="upload-img text-center">
                                <div class="btn-upload" role="button" @click="upload()">
                                    <i class="icon ion-md-cloud-upload"></i>
                                    <p class="mb-0 fs-14px">
                                        Tải ảnh lên
                                    </p>
                                </div>
                            </div>
                            <div class="img position-relative" role="button" v-for="(item, index) in images" :key="index"
                                @click="pushImage(item)">
                                <img class="w-100 h-100" :src="item.image_thum"/>
                                <div class="delete-img position-absolute" @click="destroy(item, index)">
                                    <i class="icon ion-ios-close"></i>
                                </div>
                                <div class="checked-img position-absolute" v-if="imageSelect.includes(item.image)">
                                    <div class="btn-check">
                                        <i class="icon ion-ios-checkmark"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dots-loading mb-3" v-if="loadingPage">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                        <div class="btn-loadmore-img text-center mb-3">
                            <button class="btn btn-outline-primary btn-sm" v-if="next_page && !loadingPage" @click="getData(next_page)">Tải thêm ảnh</button>
                        </div>
                    </div>
                    <div class="footer-dialog border-top border-primary text-center p-10px">
                        <button class="btn btn-primary btn-sm" @click="insert()"
                            :disabled="loading || loadingPage">Chọn ảnh</button>
                    </div>
                </ldc-dialog>
            </div>
            <input type="file" v-show="false" multiple class="input-upload"
                @change="postImage"/>
        </div>
    </div>
</template>
<script>
import { getToken } from '@/config/token';
export default {
    props: {
        content: {
            type: String,
        },
        classify: {
            type: String,
            default: 'raovat'
        }
    },
    data() {
        return {
            data: '',
            config: {
                theme: 'modern',
                menubar: false,
                height: 400,
                plugins: "textcolor",
                toolbar: 'styleselect | fontsizeselect | forecolor | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | mybutton',
                fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
                branding: false,
                convert_urls: false,
                setup:  (editor)=> {
                    editor.addButton('mybutton', {
                        text: false,
                        icon: 'mce-ico mce-i-image',
                        onclick:  () =>{
                            this.dialog = true;
                        }
                    });
                }
            },
            dialog: false,
            loadingPage: false,
            max_id: null,
            images: [],
            next_page: 0,
            imageSelect: [],
            imageSelectDefault: [],
            files: [],
            loading: false,
        }
    },
    watch: {
        content(val){
            this.data = val;
        },
        data(val){
            this.$emit('update:content', val);
        }
    },
    created() {
        this.getData(1);
        this.config.height = this.$detect == 'mobile' ? 250 : 400;
        if(this.classify == 'raovat'){
            this.config.plugins = 'textcolor | link';
            this.config.toolbar = 'styleselect | fontsizeselect | forecolor | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | link | mybutton';
        }
    },
    mounted(){
        this.data = this.content;
    },
    methods: {
        getData(page) {
            this.loadingPage = true;
            apiGet('/v2/profile/user_gallery', {
                page: page,
                max_id: this.max_id,
            }).then(res => {
                let data = res.data;
                data.data.map(item => {
                    this.images.push(item);
                });
                this.next_page = data.next_page;
                if(page == 1){
                    this.max_id = data.data[0].id;
                }
                this.loadingPage =false;
            }).catch(err => {
                this.loadingPage = false;
            })
        },
        pushImage(image){
            if(!this.imageSelect.includes(image.image)){
                this.imageSelect.push(image.image);
            }else{
                this.imageSelect.map((item, index) => {
                    if(item === image.image){
                        this.imageSelect.splice(index, 1);
                    }
                })
            }
        },
        insert(){
            if(this.imageSelect.length == 0){
                this.$message({
                    message: 'Vui lòng chọn ít nhất 1 ảnh',
                    type: 'warning',
                    center: true,
                })
            }else{
                let dom = '';
                this.imageSelect.map(item => {
                    dom += `<img src="${item}" alt="${item}" style="max-width: 100% !important"/>`;
                });
                tinymce.activeEditor.execCommand('mceInsertContent', false, dom);
                this.imageSelect = [];
                this.dialog = false;
            }
        },
        upload(){
            let input = this.$el.querySelector('.input-upload');
            input.click();
        },
        async postImage(e){
            let form;
            let iamges = e.target.files;
            this.loading = true;
            let dataStoreImage = [];
            for await (let item of iamges){
                if(item.type == 'image/jpeg' || item.type == 'image/png' || item.type == 'image/jpg'){
                    form = new FormData();
                    form.append('files', item);
                    await apiPost(`https://cdnvg.scandict.com/upload.php`, form).then(res => {
                        let data = res[0];
                        if(data.success == 1){
                            dataStoreImage.unshift(data)
                        }else{
                            this.$message({
                                message: `Upload ảnh ${item.name} bị lỗi`,
                                type: 'error',
                                center: true,
                            })
                        }
                    }).catch(err => {
                        this.$message({
                            type: 'error',
                            message: 'Lỗi hệ thống',
                            center: true,
                        });
                    })
                }
            }
            await this.storeImage(dataStoreImage);
            this.loading = false;
        },
        async storeImage(image){
            if(image.length == 0) return;
            let data = [];
            image.map(item => {
                data.unshift({
                    name: item.filename,
                    width: item.width,
                    height: item.height
                })
            });
            apiPost('/v2/profile/user_gallery', {
                images: data
            }).then(res => {
                this.$message({
                    message: res.message,
                    type: 'success',
                    center: true,
                });
                res.data.map(item => {
                    this.images.unshift({
                        id: item.id,
                        image_thum: item.image_thum,
                        image: item.image,
                    });
                    this.imageSelect.push(item.image)
                })
            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: 'Lỗi hệ thống, thêm vào kho ảnh thất bại',
                    center: true,
                });
            })
        },
        destroy(image, key){
            this.$confirm('Bạn có chắc chắn xóa ảnh này khỏi kho ảnh của bạn?', 'Xóa ảnh', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Hủy',
                type: 'error'
            }).then(() => {
                this.loading = true;
                apiDelete(`/v2/profile/user_gallery/${image.id}`).then(res => {
                    this.$message({
                        message: res.data.message,
                        type: 'success',
                        center: true,
                    });
                    this.loading = false;
                    this.images.splice(key, 1)
                    if(this.imageSelect.includes(image.image)){
                        this.imageSelect.map((item, index) => {
                            if(item === image.image){
                                this.imageSelect.splice(index, 1);
                            }
                        })
                    }
                }).catch(err => {
                    this.loading = false;;
                    if(err.status == 410){
                        this.$message({
                            message: err.data.message,
                            type: 'error',
                            center: true,
                        })
                    }
                })
            }).catch(() => {})
        }
    }
}
</script>
<style lang="scss">
    .mce-notification {display: none !important;}
    .content-edit {
        iframe{
            img{
                max-width: 100vw !important;
            }
        }
        .edit-img {
            position: absolute;
            top: 0;
            left: 445px;
            height: 33.6px;
            line-height: 33.6px;
            border-left: 1px solid #d9d9d9;
            padding: 0 10px;
        }
        .dialog-edit {
            .my-img {
                height: 400px;
                overflow: auto;
                .img {
                    width: 20%;
                    height: 140px;
                    padding: 16px 8px 0;
                    &:hover {
                        .delete-img {
                            display: block !important;
                        }
                    }
                    img {
                        box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);
                        object-fit: cover;
                        border-radius: 4px;
                    }
                    .delete-img {
                        background: rgba(189, 195, 199,0.8);
                        top: 16px;
                        right: 8px;
                        width: 25px;
                        height: 25px;
                        line-height: 25px;
                        text-align: center;
                        border-radius: 0 4px 0 0;
                        display: none;
                        i {
                            font-size: 20px;
                            color: #fff;
                        }
                    }
                }
                .upload-img {
                    width: 20%;
                    height: 140px;
                    padding: 16px 8px 0;
                    .btn-upload {
                        border-radius: 4px;
                        border: 2px dashed rgba(0,0,0,0.2);
                        height: 100%;
                        padding: 20px 0px;
                        i {
                            font-size: 30px;
                            color: #666;
                        }
                        p {
                            color: #666;
                        }
                    }
                }
                .checked-img {
                    bottom: 0;
                    right: 8px;
                    color: #fff;
                    border-radius: 0 0 4px 0;
                    overflow: hidden;
                    .btn-check {
                        width: 0;
                        height: 0;
                        border-bottom: 28px solid #28a745;
                        border-left: 28px solid transparent;
                        i {
                            margin-left: -14px;
                            font-size: 25px;
                        }
                    }
                }
            }
            .ldc-dialog-content {
                padding: 0 !important;
                .title-dialog {
                    font-size: 16px !important;
                    padding: 10px !important;
                    margin: 0 !important;
                    border-bottom: 1px solid #007bff;
                }
            }
            .footer-dialog {
                z-index: 4000;
                button {
                    width: 120px;
                }
                .btn-outline-primary {
                    &:hover {
                        background: #fff !important;
                        color: #007bff !important;
                    }
                }
            }
            .btn-loadmore-img {
                button {
                    width: 200px;
                    &:hover {
                        background: #fff !important;
                        color: #007bff !important;
                    }
                }
            }
            .dots-loading {
                display: flex;
                justify-content: center;
            }
            .dots-loading > div {
                width: 10px;
                height: 10px;
                border-radius: 10px;
                background-color: #ccc;
                margin: 0 10px;
                animation: dotLoading 1s forwards infinite linear;
            }
            .dots-loading > div:nth-child(2) {
                animation-delay: 0.1s;
            }
            .dots-loading > div:nth-child(3) {
                animation-delay: 0.2s;
            }
            .dots-loading > div:nth-child(4) {
                animation-delay: 0.3s;
            }
            @keyframes dotLoading {
                to {
                    opacity: 0;
                }
            }
        }
        .tinymce > .mce-container {
            width: unset !important;
        }
        .dialog-edit-mobile {
            .ldc-dialog-content {
                overflow: auto;
                .my-img {
                    height: unset !important;
                    margin-bottom: 61px;
                }
            }
            .title-dialog {
                top: 0 !important;
                z-index: 1;
                background: #007bff;
                color: #fff !important;
                text-align: center;
            }
            .close-modal-mobile {
                position: absolute;
                top: 0;
                z-index: 1;
                padding-top: 5px;
                i {
                    color: #fff;
                    font-size: 22px;
                    padding: 15px;
                }
            }
            .footer-dialog {
                position: fixed;
                bottom: 0 !important;
                width: 100%;
                left: 0 !important;
                background: #fff;
                button {
                    height: 40px;
                    width: 200px !important;
                }
            }
            .upload-img {
                width: 33.33333333333333% !important;
                height: 100px !important;
                padding: 16px 8 0 !important;
                .btn-upload {
                    width: 100% !important;
                    height: 100% !important;
                    padding: 5px 0 !important;
                }
            }
            .img {
                width: 33.33333333333333% !important;
                padding: 16px 8 0 !important;
                height: 100px !important;
                img {
                    width: 100% !important;
                    height: 100% !important;
                }
                .delete-img {
                    display: block !important;
                    top: 16px !important;
                    right: 8px !important;
                }
            }
        }
    }
</style>
